export default __webpack_public_path__ + "static/media/Review 4.cf319fa1.png";